/*    
<summary>
  This functional component "BarcodeScannerPopupHOC" provides props to the child component.
  1. State "showBarcodeScannerPopup" that manages the show/hide of pop up
  2. Function "barcodescannerPopupToggleHandler" to toggle the show/hide popup state "showBarcodeScannerPopup"
  Developer:Aashish Singh, Created Date:29-August-2023
</summary>
<returns>Returns JSX</returns>
*/
import React, { useState } from "react";

const BarcodeScannerPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showBarcodeScannerPopup, setShowBarcodeScannerPopup] = useState<boolean>(false);

    const barcodescannerPopupToggleHandler = () => {
      setShowBarcodeScannerPopup(!showBarcodeScannerPopup);
    };

    return (
      <Component
        showBarcodeScannerPopup={showBarcodeScannerPopup}
        barcodescannerPopupToggleHandler={barcodescannerPopupToggleHandler}
        {...props}
      />
    );
  };

export default BarcodeScannerPopupHOC;
